'use client';

import { Alert, Box } from '@unity/cloud-ui';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import themeConstants from '../theme/theme-constants';

export function FallbackLocaleBanner() {
  const t = useTranslations();
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    document.documentElement.style.setProperty(themeConstants.cssVariables.fallbackBannerHeight, '0px');
    setIsVisible(false);
  };
  if (!isVisible) return null;

  return (
    <>
      <Box height={{ xs: 0, md: themeConstants.layout.fallbackLocaleBannerHeight }} />
      <Alert
        severity="info"
        onClose={handleClose}
        sx={{
          height: { xs: 'auto', sm: themeConstants.layout.fallbackLocaleBannerHeight },
          width: '100%',
          zIndex: 10,
          position: { xs: 'sticky', md: 'fixed' },
          top: {
            xs: `calc(${themeConstants.layout.productHeaderHeight} - 1px)`,
            md: `calc(${themeConstants.layout.headerHeight} + ${themeConstants.layout.productHeaderHeight})`,
          },
          borderRadius: 0,
        }}
      >
        {t('content-renderer:default-locale-warning')}
      </Alert>
    </>
  );
}
